<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th class="mw-70">ID</th>
                    <th class="mw-70">Status</th>
                    <th class="mw-70">Table</th>
                    <th class="col20">Type</th>
                    <th class="col20">Info</th>
                    <th class="col10 center">Created at</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(tasklog, index) in tasklogs" :key="tasklog.id">
                    <td>{{ tasklog.id }}</td>
                    <td>{{ tasklog.status }}</td>
                    <td>{{ tasklog.table }}</td>
                    <td>{{ tasklog.type }}</td>
                    <td>
                        <app-button type="primary" v-on:click="showModal(tasklog.info)">
                            <ion-icon name="information-circle-outline"></ion-icon>
                        </app-button>
                    </td>
                    <td>{{ dateFormat(tasklog.created_at) }}</td>
                </tr>

                <tr v-if="tasklogs.length === 0">
                    <td class="table-empty" colspan="6">No logs!</td>
                </tr>
            </tbody>
        </table>

        <div class="modal fade" id="output-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog task-form" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        {{outputdata}}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";

export default {
    props: {
        logList: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            tasklogs: {},
            outputdata: ''
        }
    },

    created() {
        this.renderList();
    },

    methods: {
        renderList() {
            this.tasklogs = this.logList.length > 0
                ? JSON.parse(this.logList)
                : {};
        },
        dateFormat(date) {
            return moment.unix(date).utc().format('DD MMM YYYY HH:mm:ss');
        },
        showModal(output) {
            this.outputdata = output;
            $('#output-modal').modal('show');
        },
    }
}
</script>
